export default __webpack_public_path__ + "static/media/logo.0e07df8a.jpg";